export default __webpack_public_path__ + "static/media/innov-edu-final.2025a4b7.png";